import React, { Component } from 'react';
import ProjectPage from '../../components/ProjectPage';
import Table from '../../components/Table';
import Banner from '../../images/projects/RailTonBanner.jpg'

class RailTon extends Component {
  render() {
    return (
    <ProjectPage title="RailTon" banner={Banner}>

      <div className='project-page-part'>

        <Table className="centered" data = {{
          Status : "Finished",
          Type : "School Project",
          Engine : "Custom Engine",
          Language : "C++, DirectX9",
          Duration : "2 weeks",
          Team : "Group of 4",
          Date : "2023"
        }}/>

      </div>

      <div className='project-page-part'>

        <h3>Context :</h3>
        <p className='basic-text'>
          The objective of the project was to create a custom game engine using DirectX9 and C++ and make a game using it.<br/>
          It was my first experience with graphics API.
        </p>

      </div>

      <div className='project-page-part'>

        <h3>Game :</h3>
        <p className='basic-text'>
          RailTon is a railshooter in space where you have to shoot a maximum of UFO using your power to slow down time.
        </p>

      </div>

      <div className='project-page-part'>

        <h3>Gameplay :</h3>

        <iframe className='project-video' title='RailTon demo' allowFullScreen
        src="https://youtube.com/embed/4lLA6O-rXU0">
        </iframe>

      </div>

    </ProjectPage>
    );
  }
}

export default RailTon;